import React from "react";
import { Button, Modal } from "react-bootstrap";

interface DeleteConfirmationProps {
  show: boolean;
  onHide: () => void;
  onConfirmation: () => void;
  title?: string;
  description?: string;
}

const DeleteConfirmation: React.FC<DeleteConfirmationProps> = ({
  show,
  onHide,
  title,
  description,
  onConfirmation,
}) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      dialogClassName={"modal-dialog-centered"}
    >
      <Modal.Header onHide={onHide} closeButton>
        <h4 className="modal-title">{title}</h4>
      </Modal.Header>
      <Modal.Body>
        <p>{description}</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="light" onClick={onHide}>
          Cancel
        </Button>{" "}
        <Button variant="primary" onClick={onConfirmation}>
          Confirm
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteConfirmation;
